import updateRepositoryTag from 'api/v2/repository/updateRepositoryTag';
import useMutation from 'hooks/react-query/useMutation';

import type { TagItemType } from 'types/repository.types';
import useGetRepositoryTags from './useGetRepositoryTags';

const useUpdateTag = (onSuccess?: (newTag: TagItemType) => void) => {
  const tagsQuery = useGetRepositoryTags();

  const updateTagAPI = useMutation(updateRepositoryTag, {
    onSuccess: (data) => {
      tagsQuery.refetch().then(() => {
        onSuccess?.(data);
      });
    },
  });

  return updateTagAPI;
};

export default useUpdateTag;
